import { Box, Stack, Text } from "@mantine/core";
import { ReactNode } from "react";

const GridTile = ({
  icon,
  label,
  description,
  children,
  component = "div",
  onClick,
}: {
  icon: ReactNode;
  label: ReactNode;
  description?: string;
  children?: ReactNode;
  component?: "button" | "div";
  onClick?: () => void;
}) => {
  return (
    <Box
      onClick={onClick}
      component={component}
      className={`w-full relative bg-white py-3.5 px-1 text-gray-dark border border-gray-light rounded-[5px] overflow-x-auto${
        component === "button" ? " cursor-pointer" : ""
      }`}
    >
      <Stack
        align="center"
        justify="center"
        className="gap-0.5 sm:gap-1 h-full max-w-full"
      >
        {icon}
        <Stack align="center" gap={0}>
          <Text ta="center" fw={500} tt={"uppercase"} lh={1} fz={"xs"}>
            {label}
          </Text>
          <span className="text-[10px] leading-none">{description}</span>
        </Stack>
        {children}
      </Stack>
    </Box>
  );
};
export default GridTile;
